import { useEffect, useState, Fragment } from "react";
import { useSelector } from "react-redux";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import classes from "./OrderCard.module.css";
import { RootState } from "../../store";
import { ServiceAndProducts } from "../../ts/types";
import InputLabel from "../../components/Inputs/InputLabel";
import {
  getEventFullAddress,
  getFormattedDate,
  getFormattedTime,
} from "../../utils";

type Props = {
  onClick: () => void;
  disabled: boolean;
};

const OrderCard: React.FC<Props> = ({ onClick, disabled }) => {
  const { currEvent, servicesProductsOfCurrEvent, selectedDate } = useSelector(
    (state: RootState) => state.events
  );
  const { selectedServiceProducts } = useSelector(
    (state: RootState) => state.order
  );
  const [servicesAndProducts, setServicesAndProducts] = useState<
    ServiceAndProducts[]
  >([]);

  useEffect(() => {
    // Filtering Service And Selected Products from serviceId And product ids
    const servicesAndProducts: ServiceAndProducts[] = [];
    for (let i = 0; i < selectedServiceProducts?.length; i++) {
      const currServiceAndProductId = selectedServiceProducts[i];

      const { serviceId, productIds } = currServiceAndProductId;

      const serviceOfEvent = servicesProductsOfCurrEvent.find(
        (service) => service.service.id === serviceId
      );

      if (serviceOfEvent) {
        const service = serviceOfEvent.service;
        const products = serviceOfEvent.products.filter((product) =>
          productIds.includes(product.id)
        );
        servicesAndProducts.push({ service, products });
      }
    }
    setServicesAndProducts(servicesAndProducts);
  }, [selectedServiceProducts]);

  const { startTime, endTime } = currEvent;

  return (
    <div className={classes.container}>
      <div className={classes.heading}>Order Summary</div>
      <div className={classes.top}>
        <div>
          <div className={classes.headingSec}>{currEvent.name}</div>
          <div className={classes.time}>
            {`${getFormattedDate(selectedDate)} | ${getFormattedTime(
              startTime
            )} - ${getFormattedTime(endTime)}`}
          </div>
        </div>
      </div>
      <InputLabel label='Location' />
      <div className={classes.address}>{getEventFullAddress(currEvent)}</div>
      <div className={classes.serviceContainer}>
        {servicesAndProducts.map((serviceAndProducts, idx) => {
          const { service, products } = serviceAndProducts;
          return (
            <Fragment key={idx}>
              <div className={classes.serviceName}>{service.name}</div>
              {products.map((product, idx) => (
                <div className={classes.productName} key={idx}>
                  {product.name}
                </div>
              ))}
            </Fragment>
          );
        })}
      </div>
      <PrimaryButton
        className={classes.action}
        name='COMPLETE'
        onClick={onClick}
        disabled={disabled}
      />
    </div>
  );
};

export default OrderCard;
